"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatus = exports.OrderLineStatus = exports.SnapshotStatus = exports.OrderSnapshotStates = exports.OrderLineAction = void 0;
var OrderLineAction;
(function (OrderLineAction) {
    OrderLineAction["ALTERNATE_TEE_TIME_ACCEPTED"] = "ALTERNATE_TEE_TIME_ACCEPTED";
    OrderLineAction["ALTERNATE_TEE_TIME_REJECTED"] = "ALTERNATE_TEE_TIME_REJECTED";
    OrderLineAction["UPDATE_TRANSFER_LINE_CONFIG"] = "UPDATE_TRANSFER_LINE_CONFIG";
    OrderLineAction["CANCEL_LINE"] = "CANCEL_LINE";
    OrderLineAction["CANCELLED_UNAVAILABLE"] = "CANCELLED_UNAVAILABLE";
})(OrderLineAction = exports.OrderLineAction || (exports.OrderLineAction = {}));
var OrderSnapshotStates;
(function (OrderSnapshotStates) {
    OrderSnapshotStates["ORDER_RECEIVED"] = "Order received";
    OrderSnapshotStates["QUOTE_ACCEPTED_BY_CLIENT"] = "Quote accepted by client";
    OrderSnapshotStates["QUOTE_CANCELLED_BY_CLIENT"] = "Quote cancelled by client";
    OrderSnapshotStates["ALL_LINES_CONFIRMED"] = "All lines confirmed";
    OrderSnapshotStates["FULL_PAYMENT_RECEIVED"] = "Full payment received";
    OrderSnapshotStates["BALANCE_PAYMENT_RECEIVED"] = "Balance payment received";
    OrderSnapshotStates["DEPOSIT_RECEIVED"] = "Deposit received";
    OrderSnapshotStates["ORDER_CANCELLED"] = "Order cancelled";
    OrderSnapshotStates["ORDER_COMPLETED"] = "Order completed";
})(OrderSnapshotStates = exports.OrderSnapshotStates || (exports.OrderSnapshotStates = {}));
var SnapshotStatus;
(function (SnapshotStatus) {
    SnapshotStatus["DRAFT"] = "DRAFT";
    SnapshotStatus["PUBLISHED"] = "PUBLISHED";
})(SnapshotStatus = exports.SnapshotStatus || (exports.SnapshotStatus = {}));
var OrderLineStatus;
(function (OrderLineStatus) {
    OrderLineStatus["DRAFT"] = "DRAFT";
    OrderLineStatus["PENDING_CLIENT_APPROVAL"] = "PENDING_CLIENT_APPROVAL";
    OrderLineStatus["PENDING"] = "PENDING";
    OrderLineStatus["CHANGE_REQUESTED"] = "CHANGE_REQUESTED";
    OrderLineStatus["RATE_REQUESTED"] = "RATE_REQUESTED";
    OrderLineStatus["UPDATE_PENDING"] = "UPDATE_PENDING";
    OrderLineStatus["MISSING_SUPPLIER_EMAIL"] = "MISSING_SUPPLIER_EMAIL";
    OrderLineStatus["WAITING_FOR_TEE_SHEET"] = "WAITING_FOR_TEE_SHEET";
    OrderLineStatus["WAITING_FOR_SUPPLIER"] = "WAITING_FOR_SUPPLIER";
    OrderLineStatus["WAITING_FOR_CLIENT_TRANSFER_INFO"] = "WAITING_FOR_CLIENT_TRANSFER_INFO";
    OrderLineStatus["WAITING_FOR_CLIENT_TRANSFER_INFO_OVERDUE"] = "WAITING_FOR_CLIENT_TRANSFER_INFO_OVERDUE";
    OrderLineStatus["WAITING_FOR_SUPPLIER_OVERDUE"] = "WAITING_FOR_SUPPLIER_OVERDUE";
    OrderLineStatus["URGENT_ACTION_REQUIRED"] = "URGENT_ACTION_REQUIRED";
    OrderLineStatus["WAITING_TO_SEND"] = "WAITING_TO_SEND";
    OrderLineStatus["AWAITING_DEPOSIT"] = "AWAITING_DEPOSIT";
    OrderLineStatus["CONFIRMED"] = "CONFIRMED";
    OrderLineStatus["CONFIRMED_PAID"] = "CONFIRMED_PAID";
    OrderLineStatus["ALTERNATIVE_OFFERED"] = "ALTERNATIVE_OFFERED";
    OrderLineStatus["ALTERNATIVE_OFFERED_OVERDUE"] = "ALTERNATIVE_OFFERED_OVERDUE";
    OrderLineStatus["REJECTED_BY_SUPPLIER"] = "REJECTED_BY_SUPPLIER";
    OrderLineStatus["CANCELLED"] = "CANCELLED";
    OrderLineStatus["CANCELLED_UNAVAILABLE"] = "CANCELLED_UNAVAILABLE";
    OrderLineStatus["CANCELLED_REJECTED_BY_CLIENT"] = "CANCELLED_REJECTED_BY_CLIENT";
})(OrderLineStatus = exports.OrderLineStatus || (exports.OrderLineStatus = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["UNSAVED"] = "UNSAVED";
    OrderStatus["DRAFT"] = "DRAFT";
    OrderStatus["QUOTE_SENT"] = "QUOTE_SENT";
    OrderStatus["QUOTE_EXPIRING"] = "QUOTE_EXPIRING";
    OrderStatus["QUOTE_EXPIRED"] = "QUOTE_EXPIRED";
    OrderStatus["QUOTE_CANCELLED"] = "QUOTE_CANCELLED";
    OrderStatus["NEW_BOOKNG"] = "NEW_BOOKING";
    OrderStatus["CHANGE_REQUESTED"] = "CHANGE_REQUESTED";
    OrderStatus["WAITING_FOR_DEPOSIT"] = "WAITING_FOR_DEPOSIT";
    OrderStatus["RATE_REQUESTED"] = "RATE_REQUESTED";
    OrderStatus["UPDATE_PENDING"] = "UPDATE_PENDING";
    OrderStatus["READY_FOR_WORKFLOW"] = "READY_FOR_WORKFLOW";
    OrderStatus["IN_REVISION"] = "IN_REVISION";
    OrderStatus["CONFIRMING_GOLF"] = "CONFIRMING_GOLF";
    OrderStatus["CONFIRMING_HOTELS"] = "CONFIRMING_HOTELS";
    OrderStatus["CONFIRMING_ALL"] = "CONFIRMING_ALL";
    OrderStatus["WAITING_FOR_BALANCE"] = "WAITING_FOR_BALANCE";
    OrderStatus["WAITING_FOR_PAYMENT"] = "WAITING_FOR_PAYMENT";
    OrderStatus["PAYMENT_OVERDUE"] = "PAYMENT_OVERDUE";
    OrderStatus["CONFIRMED"] = "CONFIRMED";
    OrderStatus["INPROGRESS"] = "IN_PROGRESS";
    OrderStatus["COMPLETE"] = "COMPLETE";
    OrderStatus["CANCELLED"] = "CANCELLED";
    OrderStatus["CANCELLED_UNPAID"] = "CANCELLED_UNPAID";
    OrderStatus["ADDED_TO_OLD_SYSTEM"] = "ADDED_TO_OLD_SYSTEM";
    OrderStatus["CALLBACK_REQUESTED"] = "CALLBACK_REQUESTED";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
